export default __webpack_public_path__ + "static/media/dynaslope_seal_mini.8d321c72.png";